import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Form, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addOrganisationAction,
    updateOrganisationAction,
    deleteOrganisationAction
} from '../../../redux/actions/admin/adminAction';

export const Organisation = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'organisation': '' })
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'organisation': '' })
        setShow(false)
    };

    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updateOrganisation(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addOrganisation(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deleteOrganisation(id)
    }

    const [organisationsColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "Organisation", field: 'organisation', filter: true, },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])


    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={props.organisations}
                defaultColDef={defaultColDef}
                columnDefs={organisationsColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Organisations</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>

                    <Modal.Body>
                        <h3>Organisation</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="organisation"
                                name="organisation"
                                value={inputData.organisation}
                                onChange={handleChange}
                                placeholder="organisation"
                                autoComplete="off"
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>

                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const organisations = state.admin.organisations;
    return {
        organisations: organisations,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        addOrganisation: (data) => dispatch(addOrganisationAction(data)),
        updateOrganisation: (id, data) => dispatch(updateOrganisationAction(id, data)),
        deleteOrganisation: (id) => dispatch(deleteOrganisationAction(id)),

    };
};



export default connect(mapStateToProps, mapDispatchToProps)(Organisation)




